import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';

/**
 * This utility converts between a table KIND (internal to structured tables) and a
 * table TYPE (used by the spreadsheet evaluator). Because structured tables do not have
 * a separate kind for configs, we embed both the kind and whether or not it is a config
 * table into the table type string.
 *
 * In a perfect world, table type would be an opaque (or at least rich) data type. As it is,
 * the type must be a string, so we provide these conversion utilities.
 *
 * The inverse of this function is the `tableTypeToKind` function.
 */
export default function kindToTableType(kind: StructuredTableKind, isConfig: boolean): string {
  return `structured_table_${isConfig ? 'config_' : ''}${kind}`;
}
